(function (app) {
    app.provider("emailApi", [function () {
        this.$get = [
            "portalApiGateway", function (portalApiGateway) {
                var service = {};

                //Support emails
                service.createAndSendSupportEmail = function (email) {
                    return portalApiGateway.post("/Emails/Support/", email);
                };

                service.createAndSendCovidEmail = function (form) {
                    return portalApiGateway.post("/Emails/Support/Covid19", form, {
                        headers: {
                            "Content-Type": undefined
                        }
                    });
                };

                //Error logging
                service.sendDevTeamErrorEmail = function (email) {
                    return portalApiGateway.post("/Emails/Error/Covid19", email);
                };
                service.sendBasErrorEmail = function (email) {
                    return portalApiGateway.post("/Emails/Error/BusinessAnalysts", email);
                };

                return service;
            }
        ];
    }
    ]);
})(window.app);